module.exports = __webpack_public_path__ + "static/oxfordregulars-dc3b7cd32bb361cb4ccb70ab3fe19286.jpg";